import { Typography } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Button from "@material-ui/core/Button"
import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect, useState } from 'react'
import lodashGet from 'lodash.get'
import { ConfirmationDialog, useConfirmationDialogController } from "../../presentation/confirmation-dialog";

const useStyles = makeStyles((theme) => ({
    cell: {
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
    },
    container: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(0.5),
    },
    errorBorder: {
        borderColor: theme.palette.error.main,
    },
    errorText: {
        color: theme.palette.error.dark,
    },
    saveButton: {
        margin: "1rem",
        height: "2rem"
    },
    inputsWrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: 'center'
    },
    buttonsWrapper: {
        display: "flex",
        width: "100%",
        justifyContent: "space-evenly"
    },
    withMargin: {
        marginTop: "8px"
    }
}))

const HelloSsoRow = ({ name, description, feat, errorMsg, updateHelloSso, deleteHelloSso}) => {
    const classes = useStyles()
    const [isHelloSsoEnabled, setIsHelloSsoEnabled] = useState(false);
    const [helloSsoUpdated, setHelloSsoUpdated] = useState(false);
    const [helloSsoError, setHelloSsoError] = useState();

    const [helloIDP, setHelloIDP] = useState()
    const [helloDashboardIDP, setHelloDashboardIDP] = useState()

    const onConfirmSave = () => updateHelloSso({enabled: isHelloSsoEnabled, identityProvider: helloIDP, dashboardIdentityProvider: helloDashboardIDP})
    const saveDialogController = useConfirmationDialogController({ onConfirm: onConfirmSave })
    const saveConfirmMsg = `Are you sure you want to ${feat ? 'update' : 'enable'} SSO for Hello Screens?`

    const onConfirmDelete = () => deleteHelloSso()
    const deleteDialogController = useConfirmationDialogController({ onConfirm: onConfirmDelete })
    const deleteConfirmMsg = `Are you sure you want to disable SSO for Hello Screens?`

    useEffect(() => {
        setIsHelloSsoEnabled(lodashGet(feat, 'enabled', false))
        setHelloIDP(lodashGet(feat, 'identityProvider', ''))
        setHelloDashboardIDP(lodashGet(feat, 'dashboardIdentityProvider', ''))
        setHelloSsoError(errorMsg)
    }, [feat, errorMsg])

    const onChangeHelloIDP = async (event) => {
        const newValue = event.target.value;

        setHelloIDP(newValue)

        if(newValue){
            setIsHelloSsoEnabled(true)
        }

        setHelloSsoUpdated(true)
    }

    const onChangeHelloDashboardIDP = async (event) => {
        const newValue = event.target.value;

        setHelloDashboardIDP(newValue)

        if(newValue){
            setIsHelloSsoEnabled(true)
        }

        setHelloSsoUpdated(true)
    }

    return (
        <Paper {...getContainerProps(errorMsg)}>
            <ConfirmationDialog message={saveConfirmMsg} controller={saveDialogController} />
            <ConfirmationDialog message={deleteConfirmMsg} controller={deleteDialogController} />
            <Grid container>
                <Grid className={classes.cell} item xs={3}>{name}</Grid>
                <Grid className={classes.cell} item xs={6}>
                    <Typography variant="body1" align="center">
                        {description}
                        <br />
                        <Typography variant="caption" align="center" gutterBottom="true">
                        * Please contact a developer before enabling this feature, as it requires set up with the customer's external identity provider before this will work.
                        After the development work has been done to add the external provider, the identity provider name must match the name defined during the set up process.
                    </Typography>
                    </Typography>

                    
                </Grid>

                <Grid className={classes.inputsWrapper} item xs={3}>
                    <label>Hello Screens:</label>
                    <input
                        placeholder="test-provider-001"
                        value={helloIDP}
                        onChange={onChangeHelloIDP}
                    />
                    <label className={classes.withMargin}>Hello Screens Dashboard:</label>
                    <input
                        placeholder="test-provider-002"
                        value={helloDashboardIDP}
                        onChange={onChangeHelloDashboardIDP}
                    />
                    <div className={classes.buttonsWrapper}>
                        <Button
                            className={classes.saveButton}
                            color="primary"
                            variant="contained"
                            disabled={!helloSsoUpdated}
                            onClick={saveDialogController.openDialog}
                        >
                            {feat ? 'Update' : 'Save'}
                        </Button>
                        {feat && (
                            <Button
                                className={classes.saveButton}
                                color="secondary"
                                variant="contained"
                                onClick={deleteDialogController.openDialog}
                            >
                                Delete
                            </Button>
                        )}
                    </div>
                </Grid>
            </Grid>

            {helloSsoError ? (
                <Grid item xs={12}>
                    <Typography variant="body1" align="center" className={classes.errorText}>
                        {helloSsoError}
                    </Typography>
                </Grid>
            ) : (
                <></>
            )}     
        </Paper>
    )
}

const getContainerProps = (errorMsg) => {
    const classes = useStyles()

    return {
        className: classes.container + (errorMsg ? ' ' + classes.errorBorder : ''),
        variant: errorMsg ? 'outlined' : undefined,
        elevation: 0,
    }
}

export default HelloSsoRow
